import { render, staticRenderFns } from "./wenti.vue?vue&type=template&id=3193c12a&scoped=true"
import script from "./wenti.vue?vue&type=script&lang=js"
export * from "./wenti.vue?vue&type=script&lang=js"
import style0 from "./wenti.vue?vue&type=style&index=0&id=3193c12a&prod&lang=scss&scoped=true"
import style1 from "./wenti.vue?vue&type=style&index=1&id=3193c12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193c12a",
  null
  
)

export default component.exports